import React, { useState, useEffect } from 'react';
import './digital-health-accessories-wellness-and-sports-biomechanics-solutions.css';

function DigitalHealthAccessoriesWellnessAndSportsBiomechanicsSolutions() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const productCategories = [
    {
      id: 1,
      
      title: "Digital Health Accessories",
      subtitle: "Smart tools for everyday awareness",
      features: [
        "Smart wearable fitness trackers",
        "Activity monitoring devices",
        "Mobile-connected wellness accessories",
        "Lifestyle-focused digital gadgets"
      ],
   
    },
    {
      id: 2,
      
      title: "General Wellness Products",
      subtitle: "Comfort, relaxation & lifestyle enhancement",
      features: [
        "Massage guns and handheld devices",
        "Foot massagers",
        "Stress-relief and comfort tools",
        "Sleep-support gadgets"
      ],
   
    },
    {
      id: 3,
     
      title: "Fitness & Sports Biomechanics",
      subtitle: "Enhancing movement & performance",
      features: [
        "Resistance bands & strength accessories",
        "Posture support & alignment tools",
        "Movement training aids",
        "Home-based fitness kits"
      ],
      
    }
  ];

  const targetAudience = [
    { icon: "", text: "Individuals seeking wellness solutions" },
    { icon: "", text: "Fitness enthusiasts and athletes" },
    { icon: "", text: "Gyms and sports training centers" },
    { icon: "", text: "Educational institutions" },
    { icon: "", text: "Corporate wellness programs" }
  ];

  const advantages = [
    { icon: "", title: "Multidisciplinary Expertise", desc: "Integrating healthcare, engineering, and management" },
    { icon: "", title: "Global Sourcing Advantage", desc: "Direct access to innovative global products" },
    { icon: "", title: "Regulatory Awareness", desc: "Strong compliance and ethical standards" },
    { icon: "", title: "Customer-Centered", desc: "Focus on usability, affordability, and value" }
  ];

  const futurePlans = [
    "Launch private-label branded products under DR. JERY MEDICO",
    "Expand into regional and international markets",
    "Develop digital platforms and e-commerce channels",
    "Build partnerships with sports, fitness, and wellness organizations"
  ];

  return (
    <div className="dwh-master-container">
      {/* Hero Section with Coming Soon Badge */}
     <section className="dwh-hero-section">

  {/* BACKGROUND IMAGE */}
  <img
    src="/digital-accessories-banner.jpeg"
    alt="Digital Accessories Banner"
    className="dwh-hero-bg"
  />

  <div className="dwh-hero-background">
    <div className="dwh-hero-particles"></div>
  </div>

  <div className="dwh-hero-content">

    <div className="dwh-coming-soon-badge">
      <span className="dwh-pulse-dot"></span>
      Coming Soon
    </div>

<h1 className="dwh-hero-title">
  Digital Health Accessories  & &nbsp;
  <span className="dwh-mobile-break"></span>
  
  <span className="dwh-mobile-break"></span>

  <span className="dwh-hero-highlight">
   &nbsp; Wellness & &nbsp;
     <span className="dwh-mobile-break"></span>
   Sports Biomechanics 
    <span className="dwh-mobile-break"></span>
   
    <span className="dwh-mobile-break"></span>
   &nbsp; Product Marketing
  </span>
</h1>

    <p className="dwh-hero-subtitle">DR. JERY MEDICO (PVT) LTD</p>

    <div className="dwh-hero-tagline">
      Empowering Modern Lifestyles Through Innovation, Performance & Responsible Wellness
    </div>

    <button
      className="dwh-hero-cta"
      onClick={() => scrollToSection('products')}
    >
      Explore Our Solutions
      <span className="dwh-cta-arrow">→</span>
    </button>

  </div>

  <div className="dwh-hero-scroll">
    <div className="dwh-scroll-mouse"></div>
  </div>

</section>

      

      {/* Vision & Mission Section */}
      <section id="vision" className="dwh-section dwh-vision-section">
        <div className="dwh-container">
          <div className="dwh-vision-grid">
            <div className="dwh-vision-card">
              <div className="dwh-vision-icon"></div>
              <h3>Our Vision</h3>
              <p>To become a trusted provider of accessible, innovative, and ethically marketed wellness and performance solutions, enhancing the quality of life for individuals and organizations.</p>
            </div>
            <div className="dwh-mission-card">
              <div className="dwh-mission-icon"></div>
              <h3>Our Mission</h3>
              <ul>
                <li>Provide high-quality, non-clinical digital and physical wellness products</li>
                <li>Integrate technology, movement science, and lifestyle enhancement</li>
                <li>Maintain strict compliance with Sri Lankan regulatory standards</li>
                <li>Build a sustainable and scalable product portfolio</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="dwh-section dwh-products-section">
        <div className="dwh-container">
          <div className="dwh-section-header">
            <span className="dwh-section-tag">What We Offer</span>
            <h2 className="dwh-section-title">Innovative Wellness Solutions</h2>
            <div className="dwh-title-underline"></div>
            <p className="dwh-section-subtitle">Designed for everyday awareness, comfort, and performance</p>
          </div>

          <div className="dwh-products-grid">
            {productCategories.map((product, index) => (
              <div 
                key={product.id}
                className={`dwh-product-card ${hoveredCard === product.id ? 'dwh-product-hovered' : ''}`}
                onMouseEnter={() => setHoveredCard(product.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{ '--product-color': product.color }}
              >
             
                <h3 className="dwh-product-title">{product.title}</h3>
                <p className="dwh-product-subtitle">{product.subtitle}</p>
                <ul className="dwh-product-features">
                  {product.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
                <div className="dwh-product-note">
                  <span>✨</span> Non-clinical use only
                </div>
              </div>
            ))}
          </div>

          <div className="dwh-disclaimer-box">
            <div className="dwh-disclaimer-icon">⚠️</div>
            <div className="dwh-disclaimer-content">
              <strong>Important Notice:</strong> All products are intended for general wellness, fitness, and lifestyle purposes only. They are not intended for medical diagnosis, treatment, or prevention of disease.
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section id="approach" className="dwh-section dwh-approach-section">
        <div className="dwh-container">
          <div className="dwh-section-header">
            <span className="dwh-section-tag dwh-section-tag-light">Our Approach</span>
            <h2 className="dwh-section-title dwh-title-light">Global Sourcing – Local Value</h2>
            <div className="dwh-title-underline dwh-underline-light"></div>
          </div>

          <div className="dwh-approach-grid">
            <div className="dwh-approach-card">
              <div className="dwh-approach-icon"></div>
              <h3>International Partnerships</h3>
              <p>We partner with reliable manufacturers, particularly in China, to ensure competitive pricing, consistent quality, and access to global innovation.</p>
            </div>
            <div className="dwh-approach-card">
              <div className="dwh-approach-icon"></div>
              <h3>Local Operational Presence</h3>
              <p>Strong local presence ensuring efficient distribution, customer support, and market relevance in Sri Lanka.</p>
            </div>
            <div className="dwh-approach-card">
              <div className="dwh-approach-icon"></div>
              <h3>Ethical & Compliant</h3>
              <p>Products classified as non-clinical, no medical claims, ethical marketing standards, and NMRA awareness.</p>
            </div>
          </div>

          <div className="dwh-compliance-badge">
            <span className="dwh-compliance-icon">✓</span>
            Fully compliant with Sri Lankan regulatory standards including NMRA guidelines
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section id="audience" className="dwh-section dwh-audience-section">
        <div className="dwh-container">
          <div className="dwh-section-header">
            <span className="dwh-section-tag">Who We Serve</span>
            <h2 className="dwh-section-title">Trusted by Diverse Communities</h2>
            <div className="dwh-title-underline"></div>
          </div>

          <div className="dwh-audience-grid">
            {targetAudience.map((audience, idx) => (
              <div key={idx} className="dwh-audience-card">
                <div className="dwh-audience-icon">{audience.icon}</div>
                <p>{audience.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="dwh-section dwh-whyus-section">
        <div className="dwh-container">
          <div className="dwh-section-header">
            <span className="dwh-section-tag dwh-section-tag-light">Why Choose Us</span>
            <h2 className="dwh-section-title dwh-title-light">Our Distinctive Advantages</h2>
            <div className="dwh-title-underline dwh-underline-light"></div>
          </div>

          <div className="dwh-advantages-grid">
            {advantages.map((adv, idx) => (
              <div key={idx} className="dwh-advantage-card">
                <div className="dwh-advantage-icon">{adv.icon}</div>
                <h3>{adv.title}</h3>
                <p>{adv.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Future Direction Section */}
      <section id="future" className="dwh-section dwh-future-section">
        <div className="dwh-container">
          <div className="dwh-future-content">
            <div className="dwh-future-header">
              <span className="dwh-future-badge">Future Direction</span>
              <h2 className="dwh-future-title">Designed for Long-Term Growth</h2>
              <div className="dwh-future-underline"></div>
            </div>

            <div className="dwh-future-grid">
              {futurePlans.map((plan, idx) => (
                <div key={idx} className="dwh-future-card">
                  <div className="dwh-future-number">{String(idx + 1).padStart(2, '0')}</div>
                  <p>{plan}</p>
                </div>
              ))}
            </div>

            <div className="dwh-cta-box">
              <h3>Explore the Future of Wellness</h3>
              <p>At DR. JERY MEDICO (PVT) LTD, we are redefining how individuals engage with health and performance—through innovation, responsibility, and practical solutions for modern living.</p>
              <button className="dwh-cta-button" onClick={() => window.location.href = 'mailto:info@drjerymedico.com'}>
                Get Notified When We Launch
                <span>→</span>
              </button>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default DigitalHealthAccessoriesWellnessAndSportsBiomechanicsSolutions;